// extracted by mini-css-extract-plugin
module.exports = {"newsByTagContainer":"NewsByTag_newsByTagContainer__ZM-iP","heading":"NewsByTag_heading__6nTIM","pagination":"NewsByTag_pagination__+Wy1F","grid":"NewsByTag_grid__UNjzM"};